var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"latex-preview-tooltip",style:({ 
    left: _vm.position.x + 'px', 
    top: _vm.position.y + 'px' 
  })},[_c('div',{staticClass:"preview-content"},[(_vm.renderedHtml)?_c('div',{staticClass:"rendered-formula",domProps:{"innerHTML":_vm._s(_vm.renderedHtml)}}):(_vm.formula)?_c('div',{staticClass:"error-message"},[_vm._v(" 公式渲染失败: "+_vm._s(_vm.formula)+" ")]):_c('div',{staticClass:"error-message"},[_vm._v("无公式内容")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }